const dashboard = {
  dashboard: {
    welcome: "歡迎回來",
    subtitle: "您的紫微斗數分析和工具",
    recentResults: "最近結果",
    myChart: "查看我的紫微斗數",
    calculateForOthers: "為他人計算",
    learningResources: "學習資源",
    upcomingEvents: "即將到來的活動",
    viewChart: "查看星盤",
    newCalculation: "新建計算",
    exploreResources: "探索資源",
    noResults: "暫無結果",
    startCalculating: "從建立新的星盤計算開始",
    viewYourChart: "查看和分析您的個人紫微斗數星盤",
    createChartForOthers: "為朋友、家人或客戶建立並儲存星盤",
    accessResources: "存取教育內容和參考資料",
    noEvents: "暫無即將舉行的活動",
    checkBackLater: "稍後查看計劃的活動和課程",
    viewAll: "查看全部",
    viewNow: "立即查看",
    startNow: "立即開始",
    explore: "探索",
    register: "報名參加",
    quickActions: "快捷操作",
    popularResources: "熱門資源",
    updatedAgo: "{{time}}前更新",
    savedProfiles: "{{count}}個已儲存檔案",
    newBadge: "新",
    resourceLinks: {
      basics: "紫微斗數基礎入門",
      palaceSystem: "十二宮位系統詳解",
      starTypes: "主星解析與影響",
    },
    actions: {
      myChart: {
        title: "我的星盤",
        description: "查看您的個人紫微斗數星盤",
      },
      calculate: {
        title: "計算",
        description: "為他人生成星盤",
      },
    },
    table: {
      name: "姓名",
      date: "日期",
      type: "類型",
      action: "操作",
      view: "查看",
      delete: "刪除",
      gender: "性別",
      male: "男",
      female: "女",
      self: "自己",
      other: "他人",
    },
    deleteConfirmTitle: "刪除檔案",
    deleteConfirmMessage: "您確定要刪除「{{name}}」嗎？此操作無法撤銷。",
    deleteSuccess: "檔案「{{name}}」已成功刪除。",
    deleteError: "刪除檔案失敗。請重試。",
    emptyState: {
      title: "暫無結果",
      description: "從建立新的星盤計算開始。",
      action: "新建計算",
    },
  },
};

export default dashboard;
